export default function CoreFeatures() {
  const features = [
    {
      icon: 'ri-eye-line',
      title: 'Immersive Stay Experience',
      description: 'Panoramic windows, smart climate control, and premium interior design create an unforgettable living experience'
    },
    {
      icon: 'ri-lightbulb-flash-line',
      title: 'Smart Living Systems',
      description: 'Automated lighting, temperature control, entertainment systems, and voice-activated controls for ultimate convenience'
    },
    {
      icon: 'ri-drop-line',
      title: 'Full Bathroom Facilities',
      description: 'Complete bathroom with shower, modern fixtures, and efficient water management systems'
    },
    {
      icon: 'ri-funds-line',
      title: 'High ROI Potential',
      description: 'Perfect for short-stay accommodation, glamping sites, and boutique resorts with strong rental income potential'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Weather Resistant',
      description: 'Built to withstand extreme weather conditions with superior insulation and structural integrity'
    },
    {
      icon: 'ri-plug-line',
      title: 'Energy Efficient',
      description: 'Solar panel ready, LED lighting, and smart energy management reduce operational costs'
    }
  ];

  return (
    <section className="relative py-24 lg:py-32 w-full">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        {/* Section Header */}
        <div className="text-center mb-16 lg:mb-20">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-thin mb-6">
            Core <span className="text-cyan-400">Features</span>
          </h2>
          <p className="text-lg sm:text-xl text-gray-400 max-w-3xl mx-auto">
            Designed for luxury hospitality with cutting-edge technology and premium amenities
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="group relative bg-gradient-to-br from-gray-900/50 to-gray-800/30 border border-cyan-500/20 rounded-2xl p-8 hover:border-cyan-500/50 transition-all duration-300 hover:shadow-[0_0_30px_rgba(0,217,255,0.2)]"
            >
              {/* Icon */}
              <div className="w-14 h-14 bg-cyan-500/10 rounded-xl flex items-center justify-center mb-6 group-hover:bg-cyan-500/20 transition-colors">
                <i className={`${feature.icon} text-3xl text-cyan-400`}></i>
              </div>

              {/* Content */}
              <h3 className="text-xl font-medium mb-3 text-white">{feature.title}</h3>
              <p className="text-gray-400 leading-relaxed">{feature.description}</p>

              {/* Hover Effect */}
              <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/5 to-transparent rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}